import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { NAV } from "@/data/site";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-[#08162A] text-white">
        <div className="mx-auto max-w-7xl px-6 py-12">
            <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
                <Link to="/" data-testid="footer-logo" className="flex items-center gap-3">
                    <img src="/assets/logo-mark-light.png" alt="" className="h-12 w-auto" />
                    <span className="leading-tight">
                        <span className="block text-lg font-extrabold tracking-wide">DR. SERGIO JAQUEZ</span>
                        <span className="block text-[10px] font-semibold tracking-[0.3em] text-[#C9A227]">
                            EDUCATION • COUNSELING • SUPPORT
                        </span>
                        <span className="mt-0.5 flex items-center gap-2 text-[9px] font-semibold tracking-[0.35em] text-white/60">
                            <span className="h-px w-6 bg-[#C9A227]" />A PATH FORWARD
                            <span className="h-px w-6 bg-[#C9A227]" />
                        </span>
                    </span>
                </Link>

                <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label="Footer">
                    {NAV.map((n) => (
                        <Link
                            key={n.to}
                            to={n.to}
                            data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm font-medium text-white/75 transition-colors duration-200 hover:text-[#D4AF37]"
                        >
                            {n.label}
                        </Link>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    {[
                        { icon: Facebook, id: "facebook" },
                        { icon: Instagram, id: "instagram" },
                        { icon: Linkedin, id: "linkedin" },
                        { icon: Youtube, id: "youtube" },
                    ].map(({ icon: Icon, id }) => (
                        <span
                            key={id}
                            data-testid={`social-${id}`}
                            className="flex h-9 w-9 items-center justify-center rounded-md bg-white/10 text-white/85 transition-colors duration-200 hover:bg-[#C9A227] hover:text-[#0B1F3A]"
                        >
                            <Icon className="h-4 w-4" />
                        </span>
                    ))}
                </div>
            </div>

            <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-[#C9A227]/25 pt-6 sm:flex-row">
                <p className="font-script text-2xl text-[#D4AF37]">May God Bless You Today and Always.</p>
                <p className="text-xs text-white/60">© 2024 Dr. Sergio Jaquez. All rights reserved.</p>
            </div>
        </div>
    </footer>
);
